var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3964_1144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.89391 19.3113C2.89391 11.5478 11.2417 0.987826 22.9009 7.31826C27.2696 9.68348 30.247 5.27304 27.0748 3.14435C24.1403 1.10846 20.6567 0.0119367 17.0852 0C7.65217 0 0 7.27652 0 16.2643C0.0196152 19.098 0.786268 21.8764 2.22261 24.3192C3.65894 26.7619 5.71415 28.7826 8.18087 30.1774C6.58363 28.8411 5.28692 27.1822 4.37578 25.3095C3.46464 23.4369 2.95964 21.3928 2.89391 19.3113Z",
    fill: "#0582F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56559 15.5684C5.41254 23.4014 12.9952 29.2031 21.4404 25.4188C25.976 23.3875 28.6195 28.0205 25.3221 29.9545C22.2288 31.7523 18.6639 32.572 15.096 32.3058C5.74646 31.6101 1.39167 25.0431 2.00385 16.1249C2.43515 10.2675 8.87689 5.11967 15.4438 5.3701C12.8352 5.5683 10.3895 6.71542 8.56935 8.59459C6.74914 10.4738 5.68054 12.9547 5.56559 15.5684Z",
    fill: "url(#paint0_linear_3964_1144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2523 8.93188C27.2271 8.93188 28.8279 7.33101 28.8279 5.35623C28.8279 3.38145 27.2271 1.78058 25.2523 1.78058C23.2775 1.78058 21.6766 3.38145 21.6766 5.35623C21.6766 7.33101 23.2775 8.93188 25.2523 8.93188Z",
    fill: "#0582F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2523 30.4421C27.2271 30.4421 28.8279 28.8412 28.8279 26.8664C28.8279 24.8916 27.2271 23.2908 25.2523 23.2908C23.2775 23.2908 21.6766 24.8916 21.6766 26.8664C21.6766 28.8412 23.2775 30.4421 25.2523 30.4421Z",
    fill: "#0582F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3798 7.65236C33.46 7.64899 31.5977 8.30742 30.1067 9.5167C29.8848 9.65233 29.6711 9.801 29.4667 9.96192C29.3129 10.1203 29.1453 10.2646 28.9659 10.3932C27.9363 11.2141 26.6285 13.3567 25.2093 13.3567C24.6679 13.3558 24.1325 13.2429 23.6369 13.025C23.1412 12.8071 22.696 12.4889 22.3293 12.0906C22.1294 11.9351 21.9389 11.7679 21.7589 11.5897C20.8599 10.8935 19.7836 10.4633 18.6523 10.348C17.5211 10.2328 16.3801 10.4371 15.3592 10.9377C14.3382 11.4384 13.4781 12.2153 12.8765 13.1803C12.2749 14.1452 11.9561 15.2596 11.9561 16.3967C11.9561 17.5338 12.2749 18.6482 12.8765 19.6131C13.4781 20.5781 14.3382 21.3551 15.3592 21.8557C16.3801 22.3564 17.5211 22.5607 18.6523 22.4454C19.7836 22.3301 20.8599 21.8999 21.7589 21.2037C21.9389 21.0255 22.1294 20.8583 22.3293 20.7028C22.6997 20.312 23.1465 20.0017 23.642 19.791C24.1375 19.5804 24.671 19.474 25.2093 19.4784C26.6006 19.4784 27.9919 20.8697 28.9659 21.6489C29.142 21.7816 29.3093 21.9257 29.4667 22.0802L29.8146 22.3445C30.8294 23.2258 32.0421 23.849 33.3494 24.1611C34.6568 24.4732 36.0202 24.465 37.3237 24.1372C38.6272 23.8094 39.8322 23.1717 40.8365 22.2783C41.8407 21.3849 42.6143 20.2623 43.0916 19.0058C43.5689 17.7493 43.7357 16.3962 43.5779 15.0614C43.4201 13.7266 42.9424 12.4496 42.1852 11.3391C41.4281 10.2285 40.414 9.3172 39.2292 8.68261C38.0443 8.04801 36.7238 7.7089 35.3798 7.6941V7.65236Z",
    fill: "url(#paint1_linear_3964_1144)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3964_1144",
    x1: 3.35341,
    y1: 11.8675,
    x2: 22.2473,
    y2: 25.2379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#033775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#03438A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#045EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0572DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#057EEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3964_1144",
    x1: 2.92064,
    y1: 16.028,
    x2: 31.3867,
    y2: 16.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#033775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#03438A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#045EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0572DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#057EEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0582F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3964_1144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodata);
export default __webpack_public_path__ + "static/media/codata.5ebf7528b2b117529376926f0253898a.svg";
export { ForwardRef as ReactComponent };